<template>
  <div class="courses-container">
    <div
      @click="$router.push(`/Courses/Detail/${objectData.course_id}`)"
      class="img-container pointer mr-20"
    >
      <img
        class="img-courses"
        :src="objectData.banner || img.ImageDefault"
        alt=""
      />
      <button v-if="!myCourses">
        <span class="fw-700 c-main c-caption mr-5"
          >{{ formatNumber(objectData.payment_amount) }}$</span
        >
        <span
          style="font-size: 10px; margin-top:5px; text-decoration-line:line-through"
          >{{ formatNumber(objectData.origin_amount) }}$</span
        >
      </button>
    </div>
    <div class="info-container w-100">
      <div
        class="pointer"
        @click="$router.push(`/Courses/Detail/${objectData.course_id}`)"
      >
        <p style="margin-bottom: 0;" class="p-text-info flex  mt-10">
          <marquee
            class="ml-10"
            v-if="objectData?.author?.fullname?.length > 30"
            >{{ objectData?.author?.fullname }}</marquee
          >
          <span class="mr-10" v-else>{{ objectData?.author?.fullname }}</span>
          <span class="flex-shrink" style="color: #8E9195;">12 July, 2023</span>
        </p>
        <h4
          style="line-height: 1.2;min-height:85px"
          class="fw-500 mt-10 headline"
        >
          {{ objectData.headline }}
        </h4>
        <div class="flex">
          <img class="mr-10" :src="icons.PlayIcon" alt="" />
          <span class="c-caption" style="color: #8E9195;">{{
            objectData.content_info || "22h 50mite"
          }}</span>
        </div>
      </div>
      <div
        style="height:1px; background: #E3E3E3; width: 100%; margin: 15px 0"
      ></div>
      <div class="flex justify-space-between align-center pointer">
        <!-- <AddCard v-if="!myCourses" :object-data="objectData" /> -->
        <h5
          @click="handleShowDetailNew"
          style="line-height: 1.2;"
          class="fw-500 headline course_topic_name"
        >
          {{ objectData?.course_topic?.name }}
        </h5>
        <div class="flex-shrink">
          <div class="flex align-center">
            <img class="mr-5" :src="icons.StarIcon" alt="" />
            <span class="fw-500 c-title2 ">5.0</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ImageDefault from "@/assets/img/poster_video.png";
import PlayIcon from "@/assets/img/svg_edu/PlayIcon.svg";
import StarIcon from "@/assets/img/svg_edu/star.svg";
import AddCard from "../button/AddCard.vue";
import { formatNumber } from "@/utils/formatData";

export default {
  name: "CartCoursesS2",
  props: {
    objectData: {
      type: Object,
      default() {
        return {};
      }
    },
    myCourses: {
      type: Boolean,
      default: false
    }
  },
  components: {
    // AddCard
  },
  created() {},
  data() {
    return {
      img: {
        ImageDefault
      },
      icons: {
        StarIcon,
        PlayIcon
      }
    };
  },
  watch: {},
  methods: {
    handleShowDetailNew() {
      this.$router.push(`/Courses/${this.objectData.course_topic_id}`);
    },
    formatNumber
  }
};
</script>
<style scoped>
.courses-container {
  box-shadow: 0px 0px 0px 0px #b5b5b51a;

  box-shadow: 0px 7px 16px 0px #b5b5b51a;

  box-shadow: 0px 29px 29px 0px #b5b5b517;

  box-shadow: 0px 66px 40px 0px #b5b5b50d;

  box-shadow: 0px 118px 47px 0px #b5b5b503;

  box-shadow: 0px 184px 52px 0px #b5b5b500;
  border: 1px solid #c2d4e8;
  width: 350px;
  border: 1px solid #e3e3e3;
  border-radius: 8px;
  padding: 15px;
}
.headline:hover {
  text-decoration-line: underline;
}
.img-container {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  width: 320px;
}
.img-container button {
  padding: 2px 10px;
  background: #ffff;
  border-radius: 100px;
  position: absolute;
  right: 10px;
  bottom: 10px;
  z-index: 5;
}
.img-courses {
  overflow: hidden;
  width: 100%;
  height: 216px;
  object-fit: cover;
}
.p-text-info {
  color: #242f41;
}
</style>
